<script>
import TableBlock from '@/components/Analysis/TableBlockMixin';
import { extendedTimeRangesCaptions, timeRangesCaptions } from '@/pure/ComputedData';

export default {
  name: 'FocusDecay',
  mixins: [TableBlock],

  computed: {
    computedData() {
      const { sites, filteredCollaborators, useExtendedTimeRanges } = this.data;
      const computedSites = this.range ? sites.slice(this.range[0], this.range[1]) : sites;
      const headerCaption = useExtendedTimeRanges ? extendedTimeRangesCaptions : timeRangesCaptions;
      const entries = computedSites.map(site => {
        const { decayedCollaboratorsTimesByTimeRanges } = site.details;
        return [
          this.buildSiteBlock(site, filteredCollaborators, this.forcedTransport),
          ...decayedCollaboratorsTimesByTimeRanges.map(item => {
            return {
              value: item.count,
            };
          }),
        ];
      });
      return {
        data: {
          specifications: [
            {
              className: {
                big: true,
              },
            },
            ...headerCaption.map(caption => {
              return {
                type: 'heading',
                caption,
                icon: 'up',
              };
            }),
          ],
          entries,
        },
      };
    },
  },
};
</script>
